import { render, staticRenderFns } from "./PanelCompetitionSettingStoperItemCheckpoint.vue?vue&type=template&id=24909834&scoped=true&"
import script from "./PanelCompetitionSettingStoperItemCheckpoint.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionSettingStoperItemCheckpoint.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionSettingStoperItemCheckpoint.vue?vue&type=style&index=0&id=24909834&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24909834",
  null
  
)

export default component.exports